var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6141 11.7484C15.4683 10.9294 16 9.77679 16 8.5C16 6.01472 13.9853 4 11.5 4C9.01472 4 7 6.01472 7 8.5C7 9.77679 7.53174 10.9294 8.38585 11.7484C5.6914 13.1331 4 16.2512 4 19.5C4 19.6671 4.00447 19.8338 4.01333 20H6.01603C6.00541 19.835 6 19.6682 6 19.5C6 15.9101 8.46243 13 11.5 13C14.5376 13 17 15.9101 17 19.5C17 19.6682 16.9946 19.835 16.984 20H18.9867C18.9955 19.8338 19 19.6671 19 19.5C19 16.2512 17.3086 13.1331 14.6141 11.7484ZM14 8.5C14 9.88071 12.8807 11 11.5 11C10.1193 11 9 9.88071 9 8.5C9 7.11929 10.1193 6 11.5 6C12.8807 6 14 7.11929 14 8.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcn);
export default __webpack_public_path__ + "static/media/user-icn.9aece72fa215a2c408a1bf4658fb1e19.svg";
export { ForwardRef as ReactComponent };